import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { Spinner } from 'components';
import * as styles from './SocialMediaSummary.scss';

var cheerio = require('cheerio');

var RecentPostsPreview = (_dec = connect(function (state, ownProps) {
  return {
    theme: state.theme
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(RecentPostsPreview, _Component);

  var _super = _createSuper(RecentPostsPreview);

  function RecentPostsPreview() {
    var _this;

    _classCallCheck(this, RecentPostsPreview);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "pluralify", function (text, value) {
      return value !== 1 ? "".concat(text, "s") : text;
    });

    _defineProperty(_assertThisInitialized(_this), "renderIframe", function (item) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          flex: '1 1 auto',
          display: 'flex',
          justifyContent: 'space-around'
        }
      }, item.iframeSrc ? /*#__PURE__*/React.createElement("img", {
        style: {
          maxWidth: 502,
          width: '100%',
          height: '100%'
        },
        src: item.iframeSrc
      }) : /*#__PURE__*/React.createElement(Spinner, null));
    });

    _defineProperty(_assertThisInitialized(_this), "renderPostStats", function (post) {
      var theme = _this.props.theme;
      var insights = post.insights.data;
      return /*#__PURE__*/React.createElement("ul", {
        className: styles.listStyle
      }, /*#__PURE__*/React.createElement("li", {
        className: styles.overviewListItem
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.largeText,
        style: {
          color: theme.colors.secondaryColor
        }
      }, insights.post_impressions), /*#__PURE__*/React.createElement("span", {
        className: styles.smallText
      }, _this.pluralify('Impression', insights.post_impressions))), /*#__PURE__*/React.createElement("li", {
        className: styles.overviewListItem
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.largeText,
        style: {
          color: theme.colors.secondaryColor
        }
      }, insights.post_reactions_like_total), /*#__PURE__*/React.createElement("span", {
        className: styles.smallText
      }, _this.pluralify('Like', insights.post_reactions_like_total))), /*#__PURE__*/React.createElement("li", {
        className: styles.overviewListItem
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.largeText,
        style: {
          color: theme.colors.secondaryColor
        }
      }, insights.post_clicks), /*#__PURE__*/React.createElement("span", {
        className: styles.smallText
      }, _this.pluralify('Click', insights.post_clicks))), /*#__PURE__*/React.createElement("li", {
        className: styles.overviewListItem
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.largeText,
        style: {
          color: theme.colors.secondaryColor
        }
      }, insights.comments), /*#__PURE__*/React.createElement("span", {
        className: styles.smallText
      }, _this.pluralify('Comment', insights.comments))), /*#__PURE__*/React.createElement("li", {
        className: styles.overviewListItem
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.largeText,
        style: {
          color: theme.colors.secondaryColor
        }
      }, insights.page_impressions_unique), /*#__PURE__*/React.createElement("span", {
        className: styles.smallText
      }, "Reach")), /*#__PURE__*/React.createElement("li", {
        className: styles.overviewListItem
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.largeText,
        style: {
          color: theme.colors.secondaryColor
        }
      }, insights.shares), /*#__PURE__*/React.createElement("span", {
        className: styles.smallText
      }, _this.pluralify('Share', insights.shares))));
    });

    return _this;
  }

  _createClass(RecentPostsPreview, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          colors = _this$props.colors,
          posts = _this$props.posts,
          post = _this$props.post,
          section = _this$props.section,
          selectedClient = _this$props.selectedClient,
          loading = _this$props.loading;
      return /*#__PURE__*/React.createElement("div", null, posts && !!posts.length && !loading ? posts.map(function (post, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "".concat(styles.wrap, " ").concat(styles.itemPageBreak),
          key: "recentPostPreview_".concat(index)
        }, /*#__PURE__*/React.createElement("div", {
          className: styles.column
        }, _this2.renderPostStats(post.data)), /*#__PURE__*/React.createElement("div", {
          className: styles.column
        }, _this2.renderIframe(post.data)));
      }) : null, loading && /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 75
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), post && !post.length && !loading && /*#__PURE__*/React.createElement("span", null, "No posts for date range selected."));
    }
  }]);

  return RecentPostsPreview;
}(Component)) || _class);
export { RecentPostsPreview as default };